import moment from 'moment'
import { GridCellParams } from '@microservices/wiskey-react-table-component'

import { convertDisplayRuleToStyleSettingClassName, isAutocompleteOption } from '@helpers'
import { STYLE_SETTING_CLASS_NAME_PREFIX } from '@constants'
import { ConfiguredColumn, EntityType } from '@types'

type GetCellClassName = {
  column: ConfiguredColumn
  params: GridCellParams
  entity: EntityType
  globalStylesNames: { header: string; text: string }
  entityStylesNames: { header: string; text: string }
  columnStylesNames: { header: string; text: string }
  instanceId: string
}

export const getClassNameCell = (props: GetCellClassName) => {
  const {
    params,
    column,
    entity,
    columnStylesNames,
    globalStylesNames,
    entityStylesNames,
    instanceId,
  } = props

  const cellValue = params.value

  const value = isAutocompleteOption(cellValue) ? cellValue.label : cellValue?.toString()

  const styleSettingClassName = convertDisplayRuleToStyleSettingClassName({
    displayRule: column.displayRule,
    value,
    scriptData: {
      moment,
      column: { code: column.code, value: column.value },
      srcObj: params?.row,
    },
    useDisplayRule: column.useDisplayRule,
    classNamePrefix: `${STYLE_SETTING_CLASS_NAME_PREFIX}${instanceId}_`,
  })

  if (styleSettingClassName) {
    return styleSettingClassName
  }

  if (column.useLocalParameters) {
    return columnStylesNames.text
  }

  if (entity.useLocalParameters) {
    return entityStylesNames.text
  }

  return globalStylesNames.text
}
